import { ShopifyProductCollection } from '../../../../Services/ShopifyManualSortingServices';
import { PinnedShopifyProduct, ShopifyCollectionWithPinnedProducts } from '../../UI/ManualSorting/ShopifySorting/ShopifyManualSortingTypes';

export interface ShopifyCollectionPinnedProductsServiceType {
	handleSetAll: (shopifyCollectionWithPinnedProducts: ShopifyCollectionWithPinnedProducts[] | undefined) => void,
	handleAddProductPosition: (selectedCollection: ShopifyProductCollection, selectedProduct: PinnedShopifyProduct) => void,
	handleDeleteProductPositionById: (collectionId: string, productId: string) => void,
	handleDeleteProductPosition: (collectionId: string, selectedProduct: PinnedShopifyProduct) => void,
	handleDeleteAll: () => void
}

export default function ShopifyCollectionPinnedProductsService(
	setShopifyCollectionWithPinnedProducts: React.Dispatch<React.SetStateAction<ShopifyCollectionWithPinnedProducts[] | undefined>>): ShopifyCollectionPinnedProductsServiceType {

	const handleAddProductPosition = (selectedCollection: ShopifyProductCollection, selectedProduct: PinnedShopifyProduct) => {

		const addProduct = (pinnedProducts: PinnedShopifyProduct[]) => {
			const existingProduct = pinnedProducts.find(p => p.product.id === selectedProduct.product.id);
			return existingProduct
				? pinnedProducts.map(p => p.product.id === selectedProduct.product.id ? selectedProduct : p)
				: [...pinnedProducts, selectedProduct];
		};

		setShopifyCollectionWithPinnedProducts(c => {
			const definedCollections = c ?? [];
			const existingCollection = definedCollections.find(x => x.collectionId === selectedCollection.id);
			return existingCollection
				? definedCollections.map((x: ShopifyCollectionWithPinnedProducts) => x.collectionId === selectedCollection.id ? {
					...x, pinnedProducts:
						addProduct(x.pinnedProducts)
				} : x)
				: [...definedCollections, { collectionId: selectedCollection.id, label: selectedCollection.handle, pinnedProducts: [selectedProduct] }];
		});

	};

	const handleDeleteProductPosition = (collectionId: string, selectedProduct: PinnedShopifyProduct) => {
		handleDeleteProductPositionById(collectionId, selectedProduct.product.id);
	};

	const handleDeleteProductPositionById = (collectionId: string, productId: string) => {
		const removeProduct = (pinnedProducts: PinnedShopifyProduct[]) => {
			return pinnedProducts.filter(p => p.product.id !== productId);
		};

		setShopifyCollectionWithPinnedProducts(c => {
			const definedCollections = c ?? [];
			return definedCollections
				.map((x: ShopifyCollectionWithPinnedProducts) => x.collectionId === collectionId ? {
					...x, pinnedProducts:
						removeProduct(x.pinnedProducts)
				} : x)
				.filter(x => x.pinnedProducts.length > 0);
		});
	};

	const handleDeleteAll = () => {
		setShopifyCollectionWithPinnedProducts([]);
	};

	const handleSetAll = (shopifyCollectionWithPinnedProducts: ShopifyCollectionWithPinnedProducts[] | undefined) => {
		setShopifyCollectionWithPinnedProducts(shopifyCollectionWithPinnedProducts);
	};

	return {
		handleAddProductPosition,
		handleDeleteProductPosition,
		handleDeleteProductPositionById,
		handleDeleteAll,
		handleSetAll
	};
}